export default __webpack_public_path__ + "static/media/SFProDisplay-Thin.0787f886.woff";